import styled from 'styled-components';

export const Page = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 2rem;
`;

export const GlobalActions = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 1.25rem;
  margin-top: 1rem;
  padding: 0.85rem 1.25rem;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  background: #fafafa;
`;

// Plain div, not <section> — some installed browser extensions inject a
// blanket "section { margin-top: ... !important }" debug rule that would
// otherwise stomp this card's spacing.
export const FormGroup = styled.div`
  box-sizing: border-box;
  margin-top: 1.25rem;
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(20, 20, 43, 0.04);
  overflow: hidden;

  &:first-of-type {
    margin-top: 1.5rem;
  }
`;

// A div, not a button — it now hosts the toggle button plus the select-all
// checkbox and "Run selected" button as siblings, since a <button> cannot
// contain other interactive elements.
export const AccordionHeader = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  border-bottom: ${(props) => (props.open ? '1px solid #e2e2e2' : '1px solid transparent')};
  background: ${(props) => (props.open ? '#faf8fc' : '#fff')};
  transition: background 0.12s ease;
`;

// The actual expand/collapse control — only the chevron + form label.
export const ToggleButton = styled.button`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
  background: transparent;
  font: inherit;
  appearance: none;
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: 2px solid #4b286d;
    outline-offset: 2px;
  }
`;

export const AccordionPanel = styled.div`
  background: #fff;
  overflow-x: auto;
`;

export const Chevron = styled.span`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 1rem;
  color: #4b286d;
  transition: transform 0.15s ease;
  transform: rotate(${(props) => (props.open ? '90deg' : '0deg')});
`;

export const HeaderSpacer = styled.span`
  flex: 1;
`;

export const Badge = styled.span`
  flex: none;
  padding: 0.2rem 0.6rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
`;

export const Table = styled.table`
  width: 100%;
  min-width: 50rem;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 0.9375rem;
`;

export const Th = styled.th`
  padding: 0.65rem 1.25rem;
  background-color: #4b286d;
  border-bottom: 1px solid #e4e4e4;
  text-align: left;
  vertical-align: middle;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #fff;
  white-space: nowrap;
`;

export const GroupCell = styled.th`
  padding: 0.55rem 1.25rem;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #666;
`;

export const Tr = styled.tr`
  background: ${(props) => (props.active ? '#f6fafd' : 'transparent')};
  opacity: ${(props) => (props.dimmed ? 0.5 : 1)};

  &:hover td {
    background: ${(props) => (props.active ? '#f6fafd' : '#fafafa')};
  }
`;

export const Td = styled.td`
  box-sizing: border-box;
  padding: 0.85rem 1.25rem;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
`;

export const DetailsCell = styled.td`
  box-sizing: border-box;
  padding: 0 1.25rem 1.25rem;
  border-bottom: 1px solid #f0f0f0;
  background: #f6fafd;
`;

export const FrozenBanner = styled.div`
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 4px;
  background: #e5eff8;
  color: #00437d;
  font-size: 0.875rem;
`;

export const Meta = styled.p`
  margin: 0.25rem 0 0;
  color: #666;
  font-size: 0.875rem;
`;

export const Pill = styled.span`
  display: inline-block;
  padding: 0.15rem 0.6rem;
  border-radius: 12px;
  font-size: 0.8125rem;
  font-weight: 600;
  color: ${(props) => props.color};
  background: ${(props) => props.background};
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  white-space: nowrap;
`;

export const Confirm = styled.div`
  margin-top: 0.75rem;
  padding: 0.75rem;
  border-radius: 4px;
  background: #fdf3e3;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
`;

export const Notice = styled.p`
  margin: 0.75rem 0 0;
  color: ${(props) => (props.tone === 'error' ? '#772525' : '#666')};
  font-size: 0.875rem;
`;

export const LinkRow = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.75rem;
  font-size: 0.875rem;
`;
